import React, { useEffect, useState } from 'react';
import SmallContainer from '../containers/small/small-container';
import FacesAdmin from '../faces-admin/faces-admin';

function isUserAdmin() {
  // Replace with real admin check logic (e.g., decode JWT, fetch user info, etc.)
  // For now, check a localStorage flag for demonstration
  return true;
}

function FacesAdminMenu() {
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    setIsAdmin(isUserAdmin());
  }, []);

  if (isAdmin === null) return null; // or a spinner
  if (!isAdmin) {
    return (
      <SmallContainer>
        <h2>Access Denied</h2>
        <p>You do not have permission to view this page.</p>
      </SmallContainer>
    );
  }
  return <FacesAdmin />;
}

export default FacesAdminMenu;
